import { useLingui } from '@lingui/react/macro'
import { useParams } from 'next/navigation'

import { PoweredBy } from '../powered-by'
import { AnswerCard } from './answer-card'

export const SchedulingAnswerPage = () => {
	const { t } = useLingui()
	const params = useParams<{ slugOrId: string }>()

	return (
		<div className='flex min-h-screen flex-1 flex-col items-center justify-center gap-4 max-md:pt-8 max-md:pb-[60px]'>
			<div className='flex flex-col items-center gap-2'>
				<div className='mb-4 text-3xl font-bold'>{t`Je prends rendez-vous`}</div>

				<AnswerCard idOrSlug={params.slugOrId} />
				<PoweredBy />
			</div>
		</div>
	)
}
